export default {
  professorName: 'Professor Name',
  professorEmail: 'Email',
  studentAttentionSchedule: 'Student Attention Schedule',
  coexistenceRulesPrefix: 'Coexistence Rules for the',
};
